// 質問受付用の Google フォーム（運営者が作成したもの）
// この URL はヘッダー・フッター・お問い合わせセクションの「無料で質問する」ボタンで共通利用しています。
// 空にすると、サイト内の質問フォームに自動で切り替わります。
export const googleFormUrl =
  "https://docs.google.com/forms/d/e/1FAIpQLSdNuVuc6Q-cCsxVykHpkhW-SgQ3SZXSrPafYvd2OKOQhoCXNA/viewform?usp=publish-editor";

export const contactCategories = [
  "コミカレへの出願",
  "F-1ビザ申請",
  "TSI（TSIA2）",
  "4年制大学への編入",
  "留学費用・学生生活",
  "その他",
];

export const contactNotes = [
  "無料の質問受付です。有料の個別相談サービスではありません。",
  "パスポート番号、SEVIS ID、申請書類などの機密情報は入力しないでください。",
  "いただいた質問や個人情報は、無断で公開しません。",
  "記事で紹介する場合は、個人が特定されない形に整えます。",
];